<template>
    <div class="small-button" @click="emitPress">
        <icon :icon="['fal', icon]" size="me"/>
    </div>
</template>

<script>
    export default {
        name: "SmallIconButton",
        props: {
          icon: String
        },
        data: function () {
            return {

            }
        },
        methods: {
            emitPress() {
                this.$emit('press');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

.small-button {
    display: flex;
    cursor: pointer;
    background-color: lighten(#262C32, 20);
    border-radius: 5px;
    color: var(--button-font-color);
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;

}

.small-button:hover {
    background-color: #C84A4B;
}
</style>